__turbopack_context__.v({
  "className": "departuremono_993f65a9-module__vQIlcW__className",
});
